import React, { useState, useEffect, useRef } from 'react';
import './index.scss';
import Appointment from '../Appointment';
import Header from '../Header';
import Footer from '../Footer';
import Side from '../Side';
import Differ from '../Differ';
import Interior from '../Footer/Interior';
import Speed from '../Speed';
import { getSubNavs } from '../Footer/config';

let _isAnnotations = false;
export default function Controller ({style, carState, carOptions, onChange, speedData, loaded, gh }) {
  const [ mainActive, setMainActive ] = useState(-1);
  const [ appointmentOpen, setAppointmentOpen ] = useState(false);
  const [ isInterior, setIsInterior ] = useState(false);
  const [ entryAr, setEntryAr ] = useState(false);
  const [ entrySpeed, setEntrySpeed ] = useState(false);
  const [ hide, setHide ] = useState(false);
  const [ subNavVisible, setSubNavVisible ] = useState(false);

  const [ settingActive, setSettingActive ] = useState({
    headlight: false,
    size: false,
    annotations: false,
    music: true,
    differ: false,
    doors: false,
    windows: false
  });

  const subNavMap = {
    exteriors: 'exterior',
    interiors: 'interior',
    wheels: 'wheel',
    scenes: 'scene',
    views: 'view',
    setting: 'setting',
    speed: 'speed',
    differ: 'differ',
  }
  const subNavType = subNavMap[mainActive];

  const subNavs = getSubNavs(carOptions);
  const [ subActive, setSubActive ] = useState({
    exterior: subNavs.exteriors[1] ? subNavs.exteriors[1].uid : null,
    interior: subNavs.interiors[0] ? subNavs.interiors[0].uid : null,
    wheel: subNavs.wheels[0] ? subNavs.wheels[0].uid : null,
    scene: subNavs.scenes[3] ? subNavs.scenes[3].uid : null,
    view: subNavs.views[0] ? subNavs.views[0].uid : null,
  });


  const _movingSkybox = subNavs.scenes[0] && 
    [subNavs.scenes[0].uid, subNavs.scenes[3].uid].includes(subActive.scene);
  const [ movingSkybox, setMovingSkybox ] = useState(_movingSkybox);

  const audioDom = useRef(null);


  const handleAr = () => {
    if (carOptions && carOptions.ar && carOptions.ar.__supported) {
      const _entryAr = !entryAr;
      setEntryAr(_entryAr);
      setSetting('differ', false);
      setSubNavVisible(false);
      onChange('ar', {
        enabled: _entryAr,
        action: 0
      });

      handleAnnotations(_entryAr)
      // if (_entryAr) {
      //   setTimeout(() => {
      //     onChange('ar', {
      //       enabled: _entryAr,
      //       action: 0,
      //     });
      //   }, 300);
      // }
    }
  }

  const handleHide = () => {
    if (!hide) {
      if (settingActive['differ']) {
        onChange('differ', { annotations: false });
      }
      onChange('annotations', false);
      onChange('doors', { annotations: false });
    } else {
      for(const setting in settingActive) {
        setSetting(setting, settingActive[setting]);
      }
    }

    setHide(!hide);
  }

  const handleNav = (active) => {
    if (active === mainActive)  {
      setSubNavVisible(!subNavVisible);
    } else {
      setSubNavVisible(true);
    }
    setMainActive(active);

  }

  const handleSubNav = (type, subNav) => {
    control(type, subNav.uid);
  }

  const handleSideNav = (sideNav) => {
    setSetting(sideNav)
  }

  const handleSpeed = (type, params) => {
    if (type === 'moving') {
      setSetting('moving', true);
    } else {
      if (params.action === 0) {
        setSetting('moving', false);
      }
      setEntrySpeed(params.action !== 0);
      handleAnnotations(params.action === 0 ? settingActive.differ : true);
      onChange('speeder', params);
    }
  }

  const handleAnnotations = (bool) => {
    onChange('doors', {
      annotations: bool ? false : (!(_isAnnotations) || settingActive['annotations']), 
      status: new Array(4).fill(false)
    })
    onChange('trunk', {
      annotations: bool ? false : (!(_isAnnotations) || settingActive['annotations']), 
      status: false
    })
    onChange('annotations', bool ? false : settingActive['annotations']);
  }

  const handleSettingNav = (type, bool) => {
    // setSetting(type, bool)
    switch(type) {
      case 'speed':
        handleSpeed('speeder', { mode: 0, action: 1 });
        break;
      default:
        setSetting(type, bool);
        break;
        
    }
  }

  const handleDiffCarChange = (carUid) => {
    console.log('differ:', carUid);
  }

  function setSetting(type, bool) {
    const _settingActive = { ...settingActive };
    if (bool === undefined ) {
      bool = !_settingActive[type];
    }
    _settingActive[type] = bool;
    if (type === 'annotations') {
      _isAnnotations = true
      _settingActive.doors = bool
    }
    setSettingActive(_settingActive);

    switch (type) {
      case 'moving':
        if (!movingSkybox && bool) {
          (bool = false);
        }
        onChange(type, bool);
        break;
      case 'headlight':
        if (_settingActive['differ']) {
          onChange('differ', { headlight: bool });
        }
        onChange(type, bool);
        break;
      case 'annotations':
        if (_settingActive['differ']) {
          onChange('differ', { annotations: bool });
        }
        onChange(type, bool);
        onChange('doors', { 
          annotations: bool,
          // status: new Array(4).fill(_settingActive['doors'])
        })
        onChange('trunk', { 
          annotations: bool,
          // status: bool
        });
        break;
      case 'doors':
        const enabled = _isAnnotations ? _settingActive['annotations'] : true
        onChange('doors', { 
          annotations: enabled, 
          status: new Array(4).fill(bool)
        })

        onChange('trunk', { 
          annotations: enabled,
          status: bool
        });
        break;
      case 'windows':
        onChange('windows', { 
          annotations: _settingActive['annotations'], 
          status: new Array(4).fill(bool)
        })
        break;
      case 'rotate':
        onChange(type, { enabled: bool });
        break;
      case 'size':
        onChange(type, bool);
        if (_settingActive['differ']) {
          onChange('differ', { size:bool});
        }
        break;
      case 'differ':
        // setSetting('annotations', false);
        onChange(type, {
          target: bool ? '2abb7d771c73d98333489ddd0c7f5063183673ac' : null,
          size: _settingActive.size && bool
        });
        handleAnnotations(bool);
        break;
      case 'music':
        musicPlayed(bool);
        break;
      default: 
        break;
    }
  }

  function control(filed, uid) {
    const _subActive = { ...subActive };
    if (uid === subNavs.exteriors[0].uid) {
      _subActive.interior = uid;
      _subActive.exterior = uid;
    } else {
      _subActive[filed] = uid;
    }

    setSubActive(_subActive);
    const _movingSkybox = [subNavs.scenes[0].uid, subNavs.scenes[3].uid].includes(_subActive.scene)
    if (filed === 'scene') {
      setMovingSkybox(_movingSkybox);
    }
    if (!_movingSkybox) {
      setSetting('moving', false);
    }
    onChange(filed, { uid });
  }

  // 初始化
  useEffect(() => {
    // control('exterior', subNavs.exteriors[0].uid);
    // control('interior', subNavs.interiors[0].uid);

   // 兼容IOS autoplay
    window.addEventListener('touchstart', forceSafariPlayAudio, false);
    audioDom.current.addEventListener('play', () => {
        window.removeEventListener('touchstart', forceSafariPlayAudio, false);
    }, false);

    function forceSafariPlayAudio() {
        audioDom.current.load();
        audioDom.current.play();
    }

    for(const setting in settingActive) {
      if (!['music', 'doors'].includes(setting)) {
        setSetting(setting, settingActive[setting]);
      }
    }

    onChange('doors', { annotations: true });
    onChange('trunk', { annotations: true });
    _isAnnotations = false;

  }, []);

  function musicPlayed(bool) {
    audioDom.current[!bool ? 'pause' : 'play']();
  }

  return (
    <div
      style={{...style}}
    >
      {!(entrySpeed || settingActive.differ) &&
      <Header
        hide={hide}
        entryAr={entryAr}
        isInterior={isInterior}
        onIsInterior={() => {
          handleSubNav('view', subNavs.views[!isInterior ? 1 : 0]);
          if (isInterior) {
            onChange('exterior', { uid: subActive.exterior })
          }
          setIsInterior(!isInterior);
        }}
        onAr={handleAr}
        onHide={handleHide}
        onAppointment={() => setAppointmentOpen(true)}
      />}
      {settingActive.differ && !entrySpeed && loaded &&
      <Differ
        onChange={handleDiffCarChange}
        onExit={() => {
          setSetting('differ', false);
        }}
      />}
      <Side
        style={{ display: !(settingActive.differ || entrySpeed || isInterior || entryAr || hide) ? 'block' : 'none' }}
        handleSideNav={(type, bool) => handleSideNav(type, bool)}
        actives={settingActive}
      />
      <Appointment
        open={appointmentOpen}
        onClose={() => setAppointmentOpen(false)}
      />

      {!entrySpeed &&
      <div
        className="footer-container"
        style={{display: (isInterior || hide) ? 'none' : 'block'}}
      >
        <Footer
          {...{ entryAr, mainActive, carOptions, subActive, subNavVisible, subNavType, settingActive,
          handleNav, handleSubNav, handleSettingNav, loaded }}
          differ={settingActive.differ}
        />
        <audio
          id="audioHTML"
          ref={audioDom}
          style={{display: 'none'}}
          height="0"
          width="0"
          loop
          src={require('../../music/bg.mp3')}
        />
      </div>}

      <Interior
        style={{display: (hide || settingActive.differ || entrySpeed || !isInterior) ? 'none' : 'block'}}
        isInterior={isInterior}
        interiorActive={ subActive.interior }
        interiors={ subNavs.interiors }
        onInterior={(interior) => handleSubNav('interior', interior)}
        viewActive={subActive.view}
        views={ subNavs.views }
        onViews={(view) => handleSubNav('view', view)}
      />
      {entrySpeed && 
      <div style={{ display: (isInterior || hide) ? 'none' : 'block'}}>
        <Speed
          entrySpeed={entrySpeed}
          navVisible={true}
          movingSkybox={movingSkybox}
          onSpeed={handleSpeed}
          speedData={speedData}
          differ={settingActive.differ}
        />
      </div>}
    </div>
  );
}
